export default "__VITE_ASSET__08d0ff44__"